export const BIOMETHANE_REPORT_GO_ITEMS_FETCH =
  'BIOMETHANE_REPORT_GO_ITEMS_FETCH';
export const HYDROGEN_REPORT_GO_ITEMS_FETCH = 'HYDROGEN_REPORT_GO_ITEMS_FETCH';
